'use client';

import { c as _c } from "react/compiler-runtime";
import * as ChannelService from '@channel.io/channel-web-sdk-loader';
import { useEffect } from 'react';
const channelPluginKey = process.env.NEXT_PUBLIC_CHANNEL_PLUGIN_KEY ?? '';
export default function ChannelTalkInitializer() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  if (!channelPluginKey) {
    console.warn("CHANNEL_PLUGIN_KEY is not set");
    return;
  }
  ChannelService.loadScript();
  ChannelService.boot({
    pluginKey: channelPluginKey
  });
}